import * as React from 'react';
import { FieldValues, useController, UseControllerProps, useFormContext } from 'react-hook-form';
import { useGlobalFormState } from '../../../context/GlobalFormStateContext';

interface UseEditableControllerProps<TFieldValues extends FieldValues> extends UseControllerProps<TFieldValues> {}

function useEditableController<TFieldValues extends FieldValues>({
  name,
  control,
  rules,
  shouldUnregister,
  defaultValue,
}: UseEditableControllerProps<TFieldValues>) {
  const { formState, resetField } = useFormContext<TFieldValues>();
  const { field, fieldState } = useController({
    name,
    control,
    rules,
    shouldUnregister,
    defaultValue,
  });

  const revertChanges = () => {
    resetField(name, {
      keepDirty: false,
      keepError: false,
      keepTouched: false,
    });
  };
  const commitChanges = () => {
    resetField(name, {
      defaultValue: field.value,
      keepDirty: false,
      keepError: false,
      keepTouched: false,
    });
  };

  return {
    field,
    fieldState,
    formState,
    revertChanges,
    commitChanges,
  };
}

export default useEditableController;
